/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class DatatablesAPI extends ApiClient {
  constructor() {
    super('datatables/tables', { accountScoped: true, apiVersion: 'v1' });
  }

  getTables(params = {}) {
    return axios.get(this.url, { params });
  }

  getTable(slug) {
    return axios.get(`${this.url}/${slug}`);
  }

  createTable(data) {
    return axios.post(this.url, { datatable: data });
  }

  updateTable(slug, data) {
    return axios.put(`${this.url}/${slug}`, { datatable: data });
  }

  deleteTable(slug) {
    return axios.delete(`${this.url}/${slug}`);
  }

  getRows(slug, params = {}) {
    return axios.get(`${this.url}/${slug}/rows`, { params });
  }

  createRow(slug, data) {
    return axios.post(`${this.url}/${slug}/rows`, { row: { data } });
  }

  updateRow(slug, rowId, data) {
    return axios.put(`${this.url}/${slug}/rows/${rowId}`, { row: { data } });
  }

  deleteRow(slug, rowId) {
    return axios.delete(`${this.url}/${slug}/rows/${rowId}`);
  }
}

export default new DatatablesAPI();
